/* eslint-disable no-undef */
export const initWidgets = (callback, name) => {
  const checkMethodName = method => method.olsName === name;
  let timeoutCount = 0;
  function timeoutFunc() {
    if (typeof yotpo !== 'undefined') {
      const yotpoCallbacks = yotpo.allWidgetsReadyCallback;
      const shouldAddCallback =
        yotpoCallbacks && yotpoCallbacks.filter(checkMethodName).length === 0;
      if (shouldAddCallback) {
        callback.olsName = name;
        yotpo.allWidgetsReadyCallback.push(callback);
      }
      yotpo.refreshWidgets();
      yotpo.initWidgets();
    } else if (timeoutCount++ < 4) {
      window.setTimeout(timeoutFunc, timeoutCount * 500);
    }
  }
  window.setTimeout(timeoutFunc, timeoutCount);
};
/* eslint-enable no-undef */
